export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8605.c8724ef0.jpg";